<template>
<div>
<div class="page-content">
  <div class="container-fluid background">
    <div class="row">
      <img src="~@/assets/images/sunset.jpg" alt="Sunset" class="col-12 p-0">
    </div>
  </div>
  <div class="container content">
      <div class="row">
        <div class="col-12">
          <h1 class="page-header">
            Lending Library
            <hr />
          </h1>
        </div>
        <div class="col-12">
          <p>
            We have an extensive choice of books available for those who come to group meetings to borrow (but should be returned when read) and are listed below:
          </p>

          <ul>
            <li>After a Parent’s Suicide, Helping Children Heal – Margo Requarth</li>
            <li>A Special Scar, The Experiences of People Bereaved by Suicide – Alison Wertheimer</li>
            <li>Coping with Suicide – Maggie Helen</li>
            <li>Dying to be Free, A Healing Guide for Families after Suicide – Beverly Cobain, Jean Larch</li>
            <li>He Died Waiting, A bereaved mother’s view of mental health services – Caroline Aldridge</li>
            <li>Just Carry on Breathing, A Year Surviving Suicide and Widowhood – Gary Marson</li>
            <li>Life After Suicide, The Survivors’ Grief Experience – Terence W Barrett</li>
            <li>No Time to Say Goodbye, Surviving the Suicide of a Loved One – Carla Fine</li>
            <li>Silent Grief, Living in the Wake of Suicide – Christopher Lukas and Henry M Seiden</li>
            <li>Standing on my Brother’s Shoulders, Making Peace with Grief and Suicide – Tara J Lal</li>
            <li>Standing in the Shadow, Help and Encouragement for Suicide Survivors – June Cerza Kolf</li>
            <li>The Lond Sleep, Young People and Suicide – Kate Hill</li>
            <li>The Unique Grief of Suicide, Questions & Hope – Tom Smith</li>
            <li>They Died Waiting, The Crisis in Mental Health:  Stories of Loss and Stories of Hope – Caroline Aldridge & Emma Corlett</li>
            <li>Touched by Suicide, Hope and Healing After Loss – Michael F Myers and Carla Fine</li>
            <li>Understanding Your Suicide Grief, Ten Essential Touchstones for Finding Hope and Healing Your Heart – Alan D Wolfelt</li>
          </ul>

          <br/>
          <p><strong>Children’s books</strong></p>
          <ul>
            <li>I Miss You, A first look at death – Pat Thomas</li>
            <li>Missing Mummy, A book about bereavement – Rebecca Cobb</li>
            <li>Sad Isn’t Bad, A Good-Grief Guidebook for Kids Dealing With Loss – Michaelene Mundy</li>
            <li>The story of when my mum died, Alex’s Book – Lorna Vyse</li>
            <li>The story of when my mummy died, Ellie’s Book – Lorna Vyse</li>
            <li>The story of when my mum died, Ben’s Book – Lorna Vyse</li>
          </ul>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'lending-library'
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";
.page-content {
  border-bottom: 3px $primary solid;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Library.vue